import React, { Suspense, useContext, useEffect, useState } from 'react'
import { Route, Routes, BrowserRouter, Navigate } from 'react-router-dom'

import {
    AuthProvider,
    AuthIsSignedIn,
    AuthIsNotSignedIn,
} from '../context/authContext'
import { AdminPanel } from './adminPanel'
const TicketingForm = React.lazy(() => import('./ticketingForm'))
const LoginScreen = React.lazy(() => import('./loginScreen'))


const loading = (
    <div className="pt-3 text-center">
        <div className="sk-spinner sk-spinner-pulse" />
    </div>
)

export const SignInRoute = () => (
    <BrowserRouter>
        <Suspense fallback={loading}>
            <Routes>
                <Route path="/login" name="Login" element={<LoginScreen />} />
                <Route path="/" element={<TicketingForm />}/>
                <Route path="*" element={<Navigate to="/login" />} />
            </Routes>
        </Suspense>
    </BrowserRouter>
)

export const MainRoute = () => {
    return (
        <BrowserRouter>
            <Suspense fallback={loading}>
                <Routes>
                    <Route path="/admin-panel" name="Admin Panel" element={<AdminPanel />} />
                    <Route path="/ticketing-form" element={<TicketingForm />} />
                    <Route path="*" element={<Navigate to="/admin-panel" />} />
                </Routes>
            </Suspense>
        </BrowserRouter>
    )
}

export const RouteOptions = (props) => {
    const [logout, setLogout] = useState(null)


    useEffect(() => {
        if (!logout) return
        Navigate('/')
        setTimeout(() => {
            setLogout(false)
        }, 1000)
    }, [logout])


    return (
        <>

            <AuthProvider>
                <AuthIsSignedIn>
                    <MainRoute />
                </AuthIsSignedIn>
                <AuthIsNotSignedIn>
                    <SignInRoute />
                </AuthIsNotSignedIn>
            </AuthProvider>
        </>
    )
}
